import React from 'react';
import {useContext} from 'hooks';

const EntityContext = React.createContext<any>({});

export const EntityProvider = ({children, ...entities}: any) => {
	const parentContext = useContext(EntityContext);
	const value = {...parentContext, ...entities};

	return (
		<EntityContext.Provider value={value}>
			{children}
		</EntityContext.Provider>
	);
};
export const EntityConsumer = EntityContext.Consumer;
export default EntityContext;
